import styled from 'styled-components';

import * as MUIPickers from '@material-ui/pickers';
import DateFnsUtils from '@material-ui/pickers/adapter/date-fns';

export const LocalizationProvider = styled(MUIPickers.LocalizationProvider).attrs((props) => ({
	dateAdapter: DateFnsUtils,
}))``;

export const DatePicker = styled(MUIPickers.DatePicker)``;

export const DateRangePicker = styled(MUIPickers.DateRangePicker)``;
